import { useState, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Typography
} from '@mui/material';

interface WorkModelTypeMultiSelectProps {
  value: string,
  onChange: (e: any) => void,
  disabled?: boolean
}

const FrequencyDropdown = forwardRef((props: WorkModelTypeMultiSelectProps, _ref) => {
  const [types] = useState(['Weekly', 'Bi-Weekly', 'Custom']);

  return (
    <FormControl fullWidth disabled={props?.disabled ? props?.disabled : false}>
       <Typography fontWeight="light" variant="h5">
        Frequency<span style={{ color: 'red' }}>*</span>
      </Typography>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        displayEmpty
        size="small"
        value={props?.value}
        onChange={(e) => props?.onChange(e)}
      >
        <MenuItem
          style={{ display: 'none' }}
          selected
          disabled
          value={''}
        >
          Select Frequency
        </MenuItem>
        {
          types?.length > 0 &&
          types.map((type, i) => {
            return (
              <MenuItem key={i} 
                value={type.toUpperCase().replace('-', '_')}>
                  <ListItemText primary={type} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default FrequencyDropdown;
